function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import PropTypes from 'prop-types'; // Colors

import COLORS_JSON from './color_colors.json';
import GREYS_JSON from './color_greys.json';
import DAY_COLORS_JSON from 'eds-settings/themes/day/colors.json';
export var GRADIENT_COLORS = ['sunrise-orange-gradient', 'sunrise-pink-gradient', 'deepsea-blue-gradient', 'aloe-green-gradient', 'grey-gradient'];
export var COLORS = [].concat(_toConsumableArray(Object.keys(COLORS_JSON)), _toConsumableArray(Object.keys(GREYS_JSON)), GRADIENT_COLORS, _toConsumableArray(Object.keys(DAY_COLORS_JSON)));
export var COLORS_PROP_TYPE = PropTypes.oneOf(COLORS);